import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice: (state) => state.api.server.resize,
	actionType: 'SERVER_RESIZE',
	method: 'POST',
	url: '/server/resize.json',
});

export { actions, reducer, sagas, selectors };
